import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_SEMIBOLD,
  OPACITY_LOW,
  OPACITY_HOVER,
} from '@/constants/main'

export const createTextFieldStyles = (colors: {
  text: string
  primary: string
  error: string
  yellow?: string
}) => ({
  '& .MuiOutlinedInput-root': {
    color: colors.text,
    '& fieldset': {
      borderColor: colors.primary,
    },
    '&:hover fieldset': {
      borderColor: colors.primary,
    },
    '&.Mui-focused fieldset': {
      borderColor: colors.yellow || colors.primary,
    },
    '& input[type=number]': {
      MozAppearance: 'textfield' as const,
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none' as const,
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none' as const,
      margin: 0,
    },
  },
  '& .MuiInputLabel-root': {
    color: colors.text,
    opacity: OPACITY_LOW,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: colors.yellow || colors.primary,
  },
  '& .MuiFormHelperText-root': {
    color: colors.error,
    opacity: OPACITY_HOVER,
  },
})

export const createTextFieldErrorStyles = (colors: {
  text: string
  primary: string
  error: string
  yellow?: string
}) => ({
  ...createTextFieldStyles(colors),
  '& .MuiOutlinedInput-root': {
    ...createTextFieldStyles(colors)['& .MuiOutlinedInput-root'],
    '& fieldset': {
      borderColor: colors.error,
    },
    '&:hover fieldset': {
      borderColor: colors.error,
    },
    '&.Mui-focused fieldset': {
      borderColor: colors.error,
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: colors.error,
  },
})

export const createButtonStyles = (colors: {
  primary: string
  background: string
  text?: string
}) => ({
  fontWeight: FONT_WEIGHT_BOLD,
  textTransform: 'uppercase' as const,
  '&:hover': {
    backgroundColor: colors.primary,
    opacity: OPACITY_HOVER,
  },
  '&.Mui-disabled': {
    backgroundColor: `${colors.primary}40`,
    color: `${colors.background}80`,
  },
})

export const createSectionTitleStyles = (colors: { yellow: string }) => ({
  color: colors.yellow,
  mb: 2,
  fontWeight: FONT_WEIGHT_SEMIBOLD,
})

export const createCardStyles = (colors: {
  overlay: string
  primary: string
}) => ({
  backgroundColor: colors.overlay,
  borderRadius: 2,
  p: 3,
  border: `1px solid ${colors.primary}`,
})

export const createSecondaryTextStyles = (colors: { text: string }) => ({
  color: colors.text,
  opacity: OPACITY_LOW,
})

export const createDatePickerPopperStyles = (colors: {
  background: string
  primary: string
  text: string
}) => ({
  sx: {
    '& .MuiPaper-root': {
      backgroundColor: colors.background,
      border: `1px solid ${colors.primary}`,
    },
    '& .MuiPickersDay-root': {
      color: colors.text,
      '&.Mui-selected': {
        backgroundColor: colors.primary,
        color: colors.background,
      },
      '&:hover': {
        backgroundColor: `${colors.primary}20`,
      },
    },
    '& .MuiPickersCalendarHeader-root': {
      color: colors.text,
    },
    '& .MuiIconButton-root': {
      color: colors.primary,
    },
    '& .MuiPickersYear-yearButton': {
      color: `${colors.text} !important`,
      '&:hover': {
        backgroundColor: `${colors.primary}20`,
      },
      '&.Mui-selected': {
        backgroundColor: `${colors.primary} !important`,
        color: `${colors.background} !important`,
        '&:focus': {
          backgroundColor: `${colors.primary} !important`,
          color: `${colors.background} !important`,
        },
      },
    },
    '& .MuiPickersYear-root': {
      color: `${colors.text} !important`,
      '& button': {
        color: `${colors.text} !important`,
      },
    },
    '& .MuiYearCalendar-root': {
      '& .MuiPickersYear-yearButton': {
        color: `${colors.text} !important`,
        '&:hover': {
          backgroundColor: `${colors.primary}20`,
        },
        '&.Mui-selected': {
          backgroundColor: `${colors.primary} !important`,
          color: `${colors.background} !important`,
        },
      },
      '& button': {
        color: `${colors.text} !important`,
      },
    },
    '& button': {
      color: `${colors.text} !important`,
    },
  },
  placement: 'bottom-start' as const,
})

export const baseButtonStyles = (colors: { background: string }) => ({
  color: colors.background,
  fontWeight: 700,
  textTransform: 'uppercase' as const,
  px: 4,
  py: 1.5,
  minWidth: '120px',
  flex: 1,
  '&.Mui-disabled': {
    color: `${colors.background}80`,
  },
})
